<template>
<div v-if="loaded">
    <section>
        <ambassador-link></ambassador-link>
        
        <ambassador-summary></ambassador-summary>

        <ambassador-autopilot></ambassador-autopilot>
        
        <ambassador-withdrawal-history></ambassador-withdrawal-history>

        <ambassador-referral-history></ambassador-referral-history>
    </section>
</div>
<div v-else>
    <loading />
</div>

</template>

<script>
export default {
    data() {
        return {
            loaded: true,
        }
    }
}
</script>

<style>

</style>